import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Bookmark } from 'lucide-react'
import { AppShell } from '../../../shared/ui/AppShell'
import { PostsFeedView } from '../../posts/ui/PostsFeedView'
import { useBookmarks } from '../state/useBookmarks'
import { useIntersectionSentinel } from '../../../shared/hooks/useIntersectionSentinel'

export function SavedPostsPage() {
  const { t } = useTranslation('saved')

  const { posts, isLoading, error } = useBookmarks()

  const sentinel = useIntersectionSentinel({ enabled: false, onIntersect: () => {} })

  const handleLoadMore = useCallback(() => {}, [])

  return (
    <AppShell showAnalytics={false}>
      <div className="mx-auto w-full max-w-[680px] px-6 pt-8 pb-4">
        <div className="flex items-center gap-3">
          <Bookmark size={22} strokeWidth={2} className="text-primary" />
          <h1 className="m-0 text-2xl font-bold text-foreground">{t('title')}</h1>
        </div>
      </div>

      <div className="mx-auto w-full max-w-[680px] px-6 pb-8">
        {error != null ? (
          <div className="py-8 text-center text-sm text-muted-foreground">
            {t('empty')}
          </div>
        ) : (
          <PostsFeedView
            posts={posts}
            isFetchingNextPage={false}
            hasNextPage={false}
            onLoadMore={handleLoadMore}
            sentinelRef={sentinel.ref}
            isLoading={isLoading}
          />
        )}
      </div>
    </AppShell>
  )
}
